import { Decoder as EBMLDecoder, Reader as EBMLReader, tools as ebmlTools } from 'ts-ebml'

/**
 * Videos recorded through browsers are like live streams, so they don't have the duration metadata.
 * This function fixes the duration metadata of the recorded video.
 */
export default async function fixRecordedVideoDuration(inputBlob: Blob): Promise<Blob> {
  if (!inputBlob.type.startsWith('video/webm')) {
    // The following method only works on WebM files.
    return inputBlob
  }

  const reader = new EBMLReader()
  const decoder = new EBMLDecoder()

  const arrayBuffer = await inputBlob.arrayBuffer()
  const ebmlElms = decoder.decode(arrayBuffer)
  ebmlElms.forEach(element => {
    reader.read(element)
  })
  reader.stop()

  const refinedMetadataBuf = ebmlTools.makeMetadataSeekable(
    reader.metadatas,
    reader.duration,
    reader.cues
  )
  const body = arrayBuffer.slice(reader.metadataSize)
  const newBlob = new Blob([refinedMetadataBuf, body], {
    type: inputBlob.type,
  })
  return newBlob
}
